import { Gutter } from 'antd/lib/grid/row';
import { FormType } from 'enums/FieldTypeEnums';

export const CATEGORY5CONSTANTS = {
  LABELS: {
    TOTAL_WEIGHT_OF_ALL_PRODUCTS:
      'Total Weight of all products produced (tonnes)',
    TOTAL_WASTE: 'Total waste Produced (tonnes)',
    TOTAL_WASTE_WATER: 'Total Wastewater (m3)',
    WASTE_TYPE: 'Waste Type',
    WASTE_TREATMENT_METHOD: `Waste Treatment Method`,
    SWITCH_TO_MONTHLY: 'Switch to monthly',
    SWITCH_TO_ANNUALLY: 'Switch to annually',
    VIEW_MONTHLY_DATA: 'View Monthly data',
  },
  VALIDATION: {
    MONTHLY_DATA_REQUIRED: 'Monthly data is required',
    DUPLICATE_MONTH: 'Each month must be unique',
    INVALID_MONTH: 'Month must be between 1 and 12',
    MONTHLY_SUM_MISMATCH:
      'The sum of monthly values must equal total waste produced',
    YEARLY_MONTHLY_DATA: 'Monthly data must be empty for yearly entries',
  },
  FIELD_PRODUCTS_TOTAL_WEIGHT: 'productsTotalWeight',
  FIELD_TOTAL_WASTE: 'totalWasteProduced',
  FIELD_TOTAL_WASTE_WATER: 'totalWasteWater',
  FIELD_WASTETYPE_ID: 'wasteTypeId',
  FIELD_TREATMENT_METHOD: 'treatmentMethod',
  rowGutter: [50, 40] as Gutter,
  formType: FormType.REACT_HOOK_FORMS,
};
